/* global performance */

import cpuUsage from './cpu-usage'

export * from 'os-browserify'
export { default as cpus } from 'cpus'
export const loadavg = cpuUsage.loadavg
export const totalmem = () => performance ? performance.memory.totalJSHeapSize : 0
export const freemem = () => performance ? performance.memory.totalJSHeapSize - performance.memory.usedJSHeapSize : 0
